/**
 * Appearance tokens for shared product card tools (editor sheet, grammar
 * panel / ModuleWrapper, ProgressiveImage placeholders).
 *
 * Intent: THEME-1 — these components still live in `src/components` and were
 * painted with café `--bg` / `--text-primary` / `--border`, so they stayed
 * brown inside the green/paper product. Call sites use redesign roles;
 * fallbacks keep the café remnant if the same component mounts outside `.rd`
 * (BottomSheet in the admin Sidebar).
 *
 * Constraint: do not remap `:root`. Admin and founding-feedback stay on the
 * remnant palette by decision (`docs/agents/ui-and-brand.md`).
 *
 * Rejected alternative: a boolean `appearance` prop on every call site.
 * Fallbacks plus `.rd .rd-tool-surface` (primitives.css) cover both trees
 * without threading a prop through Review, Library, and Create.
 */
export const TOOL_SURFACE_CLASS = 'rd-tool-surface';

export const toolSurface = {
  sheetBg: 'var(--paper, var(--bg))',
  panelBg: 'var(--card, var(--bg-secondary))',
  fieldBg: 'var(--field, var(--bg-secondary))',
  wellBg: 'var(--paper-dark, var(--bg-tertiary))',
  fg: 'var(--fg, var(--text-primary))',
  fgSoft: 'var(--fg-soft, var(--text-secondary))',
  line: 'var(--line, var(--border))',
  actionFill: 'var(--coral, var(--action))',
  onAction: 'var(--on-action)',
} as const;
